import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../../js/base';
import { EmptyNodeList } from '../../../utility/utils/index';

class Texts extends BaseObject {
    emailsDontMatch = 'Passwords don\'t match.';
}

class ClassList extends BaseObject {
    displayNone = 'd-none';
    displayFlex = 'd-flex';
    isValid = 'is-valid';
    isInvalid = 'is-invalid';
}

class Selectors extends BaseObject {
    form = 'form';
    passwordInput = '[type="password"]';
}

class Elements extends BaseElements<Selectors> {
    passwordInputs: NodeListOf<HTMLInputElement> = new EmptyNodeList();
    wrapper: HTMLElement

    constructor(selectors: Selectors) {
        super(selectors, false);
    }

    setWrapper(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.initElements();
    }

    initElements() {
        this.passwordInputs = this.wrapper.querySelectorAll(this.selectors.passwordInput);
    }
}

interface PasswordEqualityValidation extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class PasswordEqualityValidation {
    invalid = {
        passwords: false,
        passwordFormat: false
    }

    constructor(readonly wrapper: HTMLElement) { }

    initialize(): void {
        this.elements.setWrapper(this.wrapper);
        this.addEventListeners();
    }

    addEventListeners(): void {
    }

    checkPasswordEquality() {
        const passwordInputsArray = this.base.convertToArray<HTMLInputElement>(this.elements.passwordInputs);
        const isFilled = passwordInputsArray.reduce((result, item) => !!item.value && result, true);
        const isEqual = !!passwordInputsArray.reduce((result, item) => item.value === result.value ? result : null);
        this.invalid.passwords = false;
        if (passwordInputsArray.length > 1) {
            if (isFilled) {
                passwordInputsArray[1].classList.remove(this.classList.isInvalid);
                this.destroyTooltip(passwordInputsArray[1]);
                this.invalid.passwords = false;

                if (!isEqual) {
                    passwordInputsArray[1].classList.add(this.classList.isInvalid);
                    this.setTooltip(passwordInputsArray[1], this.texts.emailsDontMatch);
                    this.invalid.passwords = true;
                }
            }
        }

        return !this.invalid.passwords;
    }

    setTooltip(el, text) {
        el.dataset.toggle = 'tooltip';
        el.setAttribute('title', text);
        $(el).tooltip()
    }

    destroyTooltip(el) {
        el.setAttribute('title', '');
        $(el).tooltip('dispose')
    }

}

export default PasswordEqualityValidation;

export {
    Elements as PasswordEqualityValidationElements,
    Selectors as PasswordEqualityValidationSelectors,
    ClassList as PasswordEqualityValidationClassList,
    Texts as PasswordEqualityValidationTexts
}